import { PageShell } from '@/components/app/page-shell';
import { ReviewLinkSettings } from '@/features/integrations-dashboard/components/review-link-settings';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authed/dashboard/settings/post-treatment-reviews'
)({
  component: PostTreatmentReviewsSettingsPage,
});

function PostTreatmentReviewsSettingsPage() {
  return (
    <PageShell className="pt-10 pb-8" maxWidth="max-w-[960px]">
      <title>Post-treatment reviews | Borrah</title>
      <ReviewLinkSettings />
    </PageShell>
  );
}
